import confirmPlugin from './confirm';

const install = (Vue) => {
  Vue.use(confirmPlugin);
};

export default {
  install,
};
